import { Col, Row } from '@/app/components/Flex/Flex'
import { DailyIcon } from '@/app/components/Layout/DailyIcon/DailyIcon'
import { Link } from '@/app/components/Link/Link'
import { Text, type TextTag } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useHasScroll } from '@/app/hooks/useHasScroll'
import { useScrollDirection } from '@/app/hooks/useScrollDirection'
import ArrowLeftSvg from '@/app/icons/arrow-left.svg?react'
import LogoutSvg from '@/app/icons/logout.svg?react'
import ProfileSvg from '@/app/icons/profile.svg?react'
import QuestionSvg from '@/app/icons/question.svg?react'
// import matrixMoneyPng from '@/app/img/layout/matrix-money.png'
import matrixPng from '@/app/img/layout/matrix.png'
import moonPng from '@/app/img/layout/moon.png'
import natalPng from '@/app/img/layout/natal.png'
import synastryJpg from '@/app/img/layout/synastry.jpg'
import { useSession } from '@/app/state/session'
import { metrikaHit } from '@/app/utils/metrika'
import classNames from 'classnames'
import type { ComponentChild, FunctionalComponent } from 'preact'
import { useEffect, useLayoutEffect, useState } from 'preact/hooks'
import { useLocation } from 'wouter-preact'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

function isActivePath(pathname: string | undefined, basePath: string) {
  return pathname === basePath || pathname?.startsWith(`${basePath}/`)
}

export const Layout: FunctionalComponent & {
  Header: FunctionalComponent<{
    class?: string
    as?: TextTag
    type?: 'secondary' | 'default'
  }>
  HeadMenu: FunctionalComponent
  Content: FunctionalComponent<{
    class?: string
    help?: boolean
    logout?: boolean
    left?: ComponentChild
    right?: ComponentChild
    fullWidth?: boolean
    onBack?: () => void
  }>
} = props => {
  const [location] = useLocation()
  const [pathname, setPathname] = useState(location)
  const user = useSession(useShallow(s => s.user))
  const ready = useSession(s => s.ready)

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      setPathname(window.location.pathname)
    }
  }, [location])

  useEffect(() => {
    metrikaHit()
  }, [])

  return (
    <UI.Wrapper>
      <div class={styles.root}>
        <div class={styles.sidebar}>
          <Row gap={40} class={styles.inner}>
            <Col
              alignItems='center'
              justifyContent='space-between'
              className={styles.head}
            >
              <Text
                fontSize={18}
                fontWeight={700}
                class={styles.logo}
              >
                ZoeAstro
              </Text>

              {ready && (
                user
                  ? (
                    <UI.Icon link='~/settings'>
                      <ProfileSvg />
                    </UI.Icon>
                  )
                  : (
                    <UI.Button
                      size='s'
                      type='primary'
                      link='~/login'
                    >
                      Вход
                    </UI.Button>
                  )
              )}
            </Col>

            <Row gap={10}>
              <Text
                upper
                fontSize={12}
                opacity={0.5}
              >
                Разборы
              </Text>

              <div class={styles.list}>
                <Link
                  to='~/tools/natal'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/tools/natal'),
                  })}
                >
                  <img class={styles.icon} src={natalPng} alt='' />
                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Натальная карта
                  </Text>
                </Link>

                <Link
                  to='~/tools/matrix'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/tools/matrix'),
                  })}
                >
                  <img class={styles.icon} src={matrixPng} alt='' />
                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Матрица судьбы
                  </Text>
                </Link>

                <Link
                  to='~/tools/synastry'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/tools/synastry'),
                  })}
                >
                  <img class={classNames(styles.icon, styles.synastry)} src={synastryJpg} alt='' />

                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Совместимость
                  </Text>
                </Link>

                <Link
                  to='~/start'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/start'),
                  })}
                >
                  <div class={styles.icon}>
                    <DailyIcon />
                  </div>

                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Дейлик
                  </Text>
                </Link>

                <Link
                  to='~/moon'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/moon'),
                  })}
                >
                  <img class={classNames(styles.icon, styles.moon)} src={moonPng} alt='' />

                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Луна
                  </Text>
                </Link>
              </div>
            </Row>

            {
              /* <Row gap={10}>
              <Text
                upper
                fontSize={12}
                opacity={0.5}
              >
                Темы
              </Text>

              <div class={styles.list}>
                <Link
                  to='~/tools/matrix-money'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/tools/matrix-money'),
                  })}
                >
                  <img class={styles.icon} src={matrixMoneyPng} alt='' />
                  <Text
                    fontSize={16}
                    fontWeight={600}
                  >
                    Денежный канал
                  </Text>
                </Link>
              </div>
            </Row> */
            }

            <Row gap={10}>
              <Text
                upper
                fontSize={12}
                opacity={0.5}
              >
                Чаты
              </Text>

              <div class={styles.list}>
                <Link
                  to='~/chats/zoe'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/chats/zoe'),
                  })}
                >
                  <UI.Avatar bot='zoe' size={40} />

                  <Row gap={5}>
                    <Text
                      fontSize={16}
                      fontWeight={600}
                      lineHeight={1}
                    >
                      Зоя
                    </Text>
                    <Text
                      fontSize={13}
                      lineHeight={1}
                    >
                      Астролог
                    </Text>
                  </Row>
                </Link>

                <Link
                  to='~/chats/milana'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/chats/milana'),
                  })}
                >
                  <UI.Avatar bot='milana' size={40} />

                  <Row gap={5}>
                    <Text
                      fontSize={16}
                      fontWeight={600}
                      lineHeight={1}
                    >
                      Милана
                    </Text>
                    <Text
                      fontSize={13}
                      lineHeight={1}
                    >
                      Нумеролог
                    </Text>
                  </Row>
                </Link>

                <Link
                  to='~/chats/eva'
                  class={classNames(styles.item, {
                    [styles.active]: isActivePath(pathname, '/chats/eva'),
                  })}
                >
                  <UI.Avatar bot='eva' size={40} />

                  <Row gap={5}>
                    <Text
                      fontSize={16}
                      fontWeight={600}
                      lineHeight={1}
                    >
                      Ева
                    </Text>
                    <Text
                      fontSize={13}
                      lineHeight={1}
                    >
                      Таролог
                    </Text>
                  </Row>
                </Link>
              </div>
            </Row>
          </Row>
        </div>

        {props.children}
      </div>
    </UI.Wrapper>
  )
}

Layout.Content = props => {
  const logout = useSession(s => s.logout)
  const hasScroll = useHasScroll()
  const toolsVisible = useScrollDirection()

  return (
    <div
      class={classNames(styles.wrapper, props.class, {
        [styles.fullWidth]: props.fullWidth,
      })}
    >
      <div
        class={classNames(styles.tools, {
          [styles.visible]: toolsVisible,
          [styles.hasScroll]: hasScroll,
        })}
      >
        <div class={classNames(styles.tool, styles.left)}>
          {props.onBack && (
            <UI.Icon onClick={props.onBack}>
              <ArrowLeftSvg strokeWidth={1.8} />
            </UI.Icon>
          )}

          {props.left}
        </div>

        <div class={classNames(styles.tool, styles.right)}>
          {props.right}

          {props.help && (
            <UI.Icon link='~/help'>
              <QuestionSvg />
            </UI.Icon>
          )}

          {props.logout && (
            <UI.Icon
              onClick={async () => {
                try {
                  const yes = confirm(
                    'Аккаунт сохранится. Войти можно в любой момент. Выйти?',
                  )
                  if (yes) {
                    await logout()
                    window.location.replace('/')
                  }
                }
                catch (e) {
                  console.error(e)
                }
              }}
            >
              <LogoutSvg strokeWidth={1.5} />
            </UI.Icon>
          )}
        </div>
      </div>

      <div class={styles.content}>
        {props.children}
      </div>
    </div>
  )
}

Layout.Header = props => (
  <div class={classNames(styles.header, props.class)}>
    {props.type === 'secondary'
      ? (
        <Text
          as={props.as}
          fontSize={16}
          fontWeight={500}
          opacity={0.5}
        >
          {props.children}
        </Text>
      )
      : (
        <Text
          as={props.as}
          fontSize={20}
          fontSizeMobile={18}
          fontWeight={600}
        >
          {props.children}
        </Text>
      )}
  </div>
)

Layout.HeadMenu = () => {
  const user = useSession(s => s.user)
  const ready = useSession(s => s.ready)

  return (
    <Col
      alignItems='center'
      justifyContent='space-between'
      class={styles.headMenu}
    >
      <Text
        fontSize={18}
        fontWeight={700}
        class={styles.logo}
      >
        ZoeAstro
      </Text>

      {ready && (
        <>
          {user
            ? (
              <Col gap={10}>
                <UI.Icon link='~/help'>
                  <QuestionSvg />
                </UI.Icon>
                <UI.Icon link='~/settings'>
                  <ProfileSvg />
                </UI.Icon>
              </Col>
            )
            : (
              <UI.Button
                size='s'
                type='primary'
                link='~/login'
              >
                Вход
              </UI.Button>
            )}
        </>
      )}
    </Col>
  )
}
